import { TextTutorialPosition, Position, TextTutorialPositionHorizontal, TextTutorialPositionVertical,
  TextTutorial } from 'types';

export const getSectionOfPosition = (position: Position): TextTutorialPosition => {
  const SECTIONS_COUNT = 3;
  const sectionWidth = window.innerWidth / SECTIONS_COUNT;
  const sectionHeight = window.innerHeight / SECTIONS_COUNT;

  const sectionX = Math.floor(position.x / sectionWidth);
  const sectionY = Math.floor(position.y / sectionHeight);

  return {
    horizontal: sectionX as TextTutorialPositionHorizontal,
    vertical: sectionY as TextTutorialPositionVertical,
  };
};

// show in same section that element
export const calculateDesiredTutorialPosition = (position: Position): TextTutorialPosition => {
  const section = getSectionOfPosition(position);
  const horizontal = section.horizontal;
  const vertical = section.vertical;

  return {
    horizontal,
    vertical,
  };
};

export const isTextString = (text: TextTutorial['text']): text is string => typeof text === 'string';
